export const CITY_SET_ERROR = 'CITY_SET_ERROR';
export const CITY_RESET = 'CITY_RESET';
export const CITY_SET_LOADING = 'CITY_SET_LOADING';
export const CITY_SET_ITEMS = 'CITY_SET_ITEMS';
export const CITY_SET_ITEM = 'CITY_SET_ITEM';

